const Skeletion = ({ viewRef }: any) => {
  return (
    <div className="overflow-hidden p-5" ref={viewRef}>
      <div className="w-full skeleton h-[220px]" />
      <div className="w-full skeleton h-[72] mt-5"></div>
    </div>
  );
};

export default Skeletion;
